export default __webpack_public_path__ + "static/media/linesSquiggle.d1e3658c.png";